/**
 * PageLoader — the ONE route-level Suspense fallback (GUI makeover item 14).
 *
 * Skeleton bars laid out in the standard page frame (header → stat row →
 * content block) so a lazily loaded route settles into place instead of
 * flashing a bare "Loading..." string. Also suitable as a whole-page
 * data-loading state.
 */
export default function PageLoader() {
  return (
    <div
      className="space-y-6 animate-fade-in"
      role="status"
      aria-busy="true"
      aria-label="Loading page"
    >
      {/* Header skeleton */}
      <div className="space-y-2">
        <div className="skeleton h-8 w-48" />
        <div className="skeleton h-4 w-72 max-w-full" />
      </div>

      {/* Stat row skeleton */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="skeleton h-24 rounded-xl" />
        ))}
      </div>

      {/* Content block skeletons */}
      <div className="skeleton h-64 rounded-xl" />
      <div className="skeleton h-40 rounded-xl" />

      <span className="sr-only">Loading…</span>
    </div>
  )
}
